import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentService } from '../../core/services/appointment.service';
import { CalendarService } from '../../core/services/calendar.service';
import { Appointment } from '../../core/models/appointment.model';

@Component({
  selector: 'app-confirm-booking',
  standalone: false,
  templateUrl: './confirm-booking.component.html',
  styleUrl: './confirm-booking.component.scss'
})
export class ConfirmBookingComponent implements OnInit {
  appointment: Appointment | null = null;
  notFound = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apptSvc: AppointmentService,
    private calendarSvc: CalendarService,
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.queryParamMap.get('id');
    if (!id) { this.notFound = true; return; }
    const apts = this.apptSvc.getAllSnapshot();
    this.appointment = apts.find(a => a.id === id) ?? null;
    if (!this.appointment) { this.notFound = true; return; }
    if (this.appointment.status === 'pending') {
      this.apptSvc.confirm(id);
      this.appointment = { ...this.appointment, status: 'confirmed' };
    }
  }

  formatDateFull(dateStr: string): string {
    const d = new Date(dateStr + 'T00:00:00');
    return d.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  }

  downloadIcs(): void {
    if (this.appointment) this.calendarSvc.downloadIcs(this.appointment);
  }

  openGoogle(): void {
    if (this.appointment) this.calendarSvc.openGoogleCalendarLink(this.appointment);
  }

  goBooking(): void {
    this.router.navigate(['/booking']);
  }
}